// FAQ js 
$('.faq-container').each(function () {
  const $container = $(this);
  $container.find('.faq-question').first().addClass('active');
  $container.find('.faq-answer').first().show();
  $container.find('.faq-question').click(function () {
    const $answer = $(this).next('.faq-answer');
    $container.find('.faq-answer').not($answer).slideUp();
    $container.find('.faq-question').not(this).removeClass('active');
    $answer.slideToggle();
    $(this).toggleClass('active');
  });
});
// end ========================


document.addEventListener("DOMContentLoaded", function () {

  // ================================= counter 
  const counters = document.querySelectorAll('.counter');
  const speed = 200;
  let hasAnimated = false;
  function runCounters() {
    counters.forEach(counter => {
      const updateCount = () => {
        const target = +counter.getAttribute('data-target');
        const count = +counter.innerText;
        const inc = target / speed;

        if (count < target) {
          counter.innerText = Math.ceil(count + inc);
          setTimeout(updateCount, 10);
        } else {
          counter.innerText = target >= 1000 ? Math.round(target / 1000) : target;
        }
      };
      updateCount();
    });
  }
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasAnimated) {
        runCounters();
        hasAnimated = true;
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5
  });

  const counterSection = document.querySelector('.counter-section');
  if (counterSection) {
    observer.observe(counterSection);
  }
  // counter end ==================================================
});

// service slider
function equalizeCardHeights() {
  const cards = document.querySelectorAll('.sub_brands_card');

  // Reset all heights
  cards.forEach(card => {
    card.style.height = 'auto';
  });

  // Let layout settle
  requestAnimationFrame(() => {
    let maxHeight = 0;
    cards.forEach(card => {
      const height = card.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    cards.forEach(card => {
      card.style.height = maxHeight + 'px';
    });
  });
}

  var swiper = new Swiper(".sub_brands_Swiper", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 30,
    loop: false,
    pagination: {
      el: ".sub_brands_silder_pagination",
      clickable: true,
    },
    grid: {
      rows: 2,
      fill: 'row',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        grid: {
          rows: 2
        }
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        grid: {
          rows: 2
        }
      },
      1025: {
        slidesPerGroup: 3,
        slidesPerView: 3,
        grid: {
          rows: 2
        }
      }
    }
  });

// Also call it on page load as fallback
window.addEventListener('load', () => {
  setTimeout(equalizeCardHeights, 1000); // Wait for any late-loaded fonts/images
});


function equalizeCardHeights() {
  const cards = document.querySelectorAll('.sub_brands_card');

  // Reset heights first
  cards.forEach(card => {
    card.style.height = 'auto';
  });

  // Wait a tick to allow layout updates
  requestAnimationFrame(() => {
    let maxHeight = 0;
    cards.forEach(card => {
      const height = card.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    cards.forEach(card => {
      card.style.height = maxHeight + 'px';
    });
  });
}

// End Sercice slider
// Awards and achivement accordian
const isMobile = () => window.innerWidth <= 1024;

function resetAll() {
  $('.awards__item').removeClass('active-item');
  $('.awards__image').removeClass('active-item');
  $('.awards__text-mobile').removeClass('active-item');
}

// Desktop interaction
$('.awards__item').each(function () {
  const $item = $(this);
  const index = $item.data('index');

  $item.on('mouseenter', function () {
    if (!isMobile()) {
      resetAll();
      $item.addClass('active-item');
      $('#' + index).addClass('active-item');
    }
  });
});

// Mobile interaction
if (isMobile()) {
  $(document).ready(function () {
    const $items = $('.awards__item');
    const $texts = $('.awards__text-mobile');

    $texts.hide();
    $items.removeClass('active-item');

    const $firstItem = $items.first();
    $firstItem.addClass('active-item');
    $firstItem.find('.awards__text-mobile').slideDown();

    $items.click(function () {
      const $this = $(this);
      const $text = $this.find('.awards__text-mobile');

      $items.not($this)
        .removeClass('active-item')
        .find('.awards__text-mobile').slideUp();

      $this.toggleClass('active-item');
      $text.stop(true, true).slideToggle();
    });
  });
}

// end awards and achivement accordian
// Video Galley SEction
var video_gallery_silder = new Swiper(".video_gallery_silder", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  autoplay: {
    delay: 10000, // 10 seconds
    disableOnInteraction: true,
  },
   
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
    },
    1025: {
      slidesPerView: 3,
     
    }
  }
});
function equalizeVideoTitles() {
  const titles = document.querySelectorAll('.template-index .video_gallery_text');
  let maxHeight = 0;

  titles.forEach(title => {
    title.style.height = 'auto'; // reset first
    maxHeight = Math.max(maxHeight, title.offsetHeight);
  });

  titles.forEach(title => {
    title.style.height = maxHeight + 'px';
  });
}

// Run on load, resize, and Swiper slide change
window.addEventListener('DOMContentLoaded', equalizeVideoTitles);
window.addEventListener('resize', equalizeVideoTitles);
video_gallery_silder.on('slideChangeTransitionEnd', equalizeVideoTitles);



// Testimonial Section
var testimonials_silder = new Swiper(".template-index .testimonials_silder", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  autoHeight: true,
  
  autoplay: {
    delay: 10000, // 10 seconds
    disableOnInteraction: true,
  },
    pagination: {
      el: ".testimonials_silder_pagination",
      clickable: true,
    },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
    },
    1025: {
      slidesPerView: 2,
    }
  }
});

// End Tesimonial Section